<div class="wrapper">
  @if (appState.isAuthenticated$ | async) {
    <ok-navigation-menu [menuItems]="menuItems()" [bottomMenuItems]="bottomMenuItems()"></ok-navigation-menu>
  }
  <main>
    <div>
      <router-outlet></router-outlet>
    </div>
    <footer>
      <img routerLink="/" src="assets/images/ok-logo.svg" alt="OK a.m.b.a" matTooltip="Gå til forsiden" />
      <div class="page__version">Version: {{ version }} &nbsp;&middot;&nbsp; Bruger: {{ userName }}</div>
    </footer>
  </main>
</div>
